/* eslint-disable @typescript-eslint/ban-ts-comment */
import { groupBy } from "lodash";
import { useEffect, useMemo, useRef } from "react";
import styled from "styled-components";

import { ApiRoute, ApiVenueMap } from "../types";
import Map from "./Map";
import MapRoutePin from "./MapRoutePin";

// @ts-ignore
const spotPattern = new URL("../../assets/spot-pattern.png", import.meta.url);

const MapsContainer = styled.div<{ hasActiveRoute: boolean }>`
  height: 100vw;
  overflow-x: auto;
  display: flex;
  max-height: 45vh;
  background-image: url(${spotPattern.toString()});
  background-color: #161541;
  padding-top: 10px;
  padding-bottom: 10px;
  scroll-snap-type: x mandatory;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */

  > * {
    width: 100vw;
    flex-shrink: 0;
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }

  &::-webkit-scrollbar {
    background: transparent; /* Chrome/Safari/Webkit */
    width: 0px;
  }

  .route-pin {
    opacity: ${({ hasActiveRoute }) => (hasActiveRoute ? 0.7 : 1)};
    /* *:not(.indicator) {
      opacity: ${({ hasActiveRoute }) => (hasActiveRoute ? 0 : 1)};
    } */
    &.selected {
      opacity: 1;
      * {
        opacity: 1 !important;
      }
    }
  }
`;

const MapsSlider = ({
  maps,
  routes,
  selectedRouteUUID,
  selectedCategoryUUID,
  onRouteClick,
}: {
  maps: ApiVenueMap[];
  routes: ApiRoute[];
  currentRoutes?: ApiRoute[];
  onRouteClick?: (uuid: string) => void;
  selectedCategoryUUID?: string;
  selectedRouteUUID?: string | null;
}) => {
  const containerRef = useRef<HTMLDivElement>();

  const routesByMap = useMemo(() => {
    // const currentRoutes = store.viewingItem
    //   ? routes.filter(
    //       (x) =>
    //         !!store.viewingItem.section.suggestions.find(
    //           (y) => y.route === x.uuid
    //         )
    //     )
    //   : store.currentItem
    //   ? routes.filter(
    //       (x) =>
    //         !!store.currentItem.section.suggestions.find(
    //           (y) => y.route === x.uuid
    //         )
    //     )
    //   : routes;
    return groupBy(routes, "map");
  }, [routes]);

  useEffect(() => {
    let mapIndex = 0;
    if (selectedRouteUUID) {
      mapIndex = maps.findIndex(
        (x) =>
          x.uuid ===
          routes.find((route) => route.uuid === selectedRouteUUID)?.map
      );
    }
    containerRef.current?.children?.[mapIndex]?.scrollIntoView({
      behavior: "smooth",
    });
  }, [routes, selectedRouteUUID, maps]);

  return (
    <MapsContainer
      hasActiveRoute={selectedRouteUUID !== undefined}
      // @ts-ignore
      ref={containerRef}
    >
      {maps.map((mapData) => (
        <Map
          bboxPadding={5}
          map={mapData}
          zoomToBbox={false}
          maxZoom={1}
          //@ts-ignore
          mapObjects={(routesByMap[mapData.uuid] || []).filter(
            (x) => x.mapPosition
          )}
          //@ts-ignore
          renderMapObject={(data: ApiRoute, transform) => {
            if (data.mapPosition === null) {
              return null;
            }
            const pos = transform(data.mapPosition.x, data.mapPosition.y);
            return (
              <MapRoutePin
                active={data.uuid === selectedRouteUUID}
                selectedCategoryUUID={selectedCategoryUUID}
                route={data}
                position={pos}
                key={data.uuid}
                onClick={() => onRouteClick?.(data.uuid)}
              />
            );
          }}
          key={mapData.uuid}
        />
      ))}
    </MapsContainer>
  );
};
export default MapsSlider;
